<template>
  <div>
    navbar
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>

</style>